import setCalendarProcessingOperation from 'owa-service/lib/operation/setCalendarProcessingOperation';
import setCalendarProcessingRequest from 'owa-service/lib/factory/setCalendarProcessingRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Service call to set calendar processing options
 */
export default function setCalendarProcessingOptions(options) {
    return setCalendarProcessingOperation(setCalendarProcessingRequest({
        Header: getJsonRequestHeader(),
        Options: options,
    }));
}
//# sourceMappingURL=setCalendarProcessingOptions.js.map